import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { handleLogin } from "../../../core/api/auth";
import { useDispatch } from "react-redux";
import { UAParser } from "ua-parser-js";
import { getCurrentUser } from "../../../core/api/settings";
import { orderOfPage } from "../../../Router/all_routes";
import { setProfile } from "../../../core/redux/action";

const Signin = () => {
  const navigate = useNavigate();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const login = async (e) => {
    e.preventDefault();
    setError("");

    const { email, password } = formData;

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    const username = email;
    
    // Collect device and browser information
    const parser = new UAParser();
    const browserResult = parser.getBrowser();
    const deviceResult = parser.getDevice();
    const osResult = parser.getOS();
    
    // Format device info
    const deviceInfo = JSON.stringify({
      type: deviceResult.type || 'unknown',
      model: deviceResult.model || 'unknown',
      vendor: deviceResult.vendor || 'unknown',
      os: osResult.name + ' ' + (osResult.version || ''),
    });
    


    // Format browser info
    const browserInfo = JSON.stringify({
      name: browserResult.name || 'unknown',
      version: browserResult.version || 'unknown',
      userAgent: navigator.userAgent,
    });

    try {
      // Send login credentials along with device/browser info
      const response = await dispatch(handleLogin({ 
        username, 
        password,
        device_info: deviceInfo,
        browser_info: browserInfo,
      }));
      if (response?.access) {
      sessionStorage.setItem("accessToken", response.access);

      const user = await getCurrentUser();

      // Set profile in Redux
      dispatch(setProfile(user));

      sessionStorage.setItem("page_permissions", JSON.stringify(user.page_permissions));
      sessionStorage.setItem("page_authorization", JSON.stringify(user.page_authorization));
      sessionStorage.setItem("client_permission", JSON.stringify(user.client_permission));
      sessionStorage.setItem("user_role", user.role);

      // Take the keys and sort them by the orderOfPages in case he got some nested routes access. When he is normal user
      let destination = null;
      if(user.role === 'super_admin')
        destination = '/products/list';
      else
        destination = Object.keys(user.page_permissions).sort((page1, page2) => orderOfPage[page1] - orderOfPage[page2])[0]
      
      // When user got no permissions yet. and he isn't an super admin
      if(destination === null || destination === undefined)
        destination = '/no-permissions'
      
      console.log(`[Signin] Navigating to ${destination}`);
      
      navigate(destination);
    }
    } catch (error) {
      setError("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    }
  };

  const route = all_routes;

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content">
            <form
              onSubmit={(e) => {
                console.log('sign in man');
                
                login(e);
              }}
            >
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
                <div className="login-userheading">
                  <h3>Sign In</h3>
                  <h4>
                    Access the DataVision panel using your email and password.
                  </h4>
                </div>

                <div className="form-login mb-3">
                  <label className="form-label">Email Address</label>
                  <div className="form-addons">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                </div>

                <div className="form-login mb-3">
                  <label className="form-label">Password</label>
                  <div className="pass-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="pass-input form-control"
                      required
                    />
                    <span
                      className={`fas toggle-password ${
                        isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                      }`}
                      onClick={togglePasswordVisibility}
                    ></span>
                  </div>
                </div>

                <div className="form-login authentication-check" hidden>
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Remember me
                        </label>
                      </div>
                      <div className="text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                {error && <p className="text-danger">{error}</p>}

                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Sign In
                  </button>
                </div>

                <div className="signinform">
                  <h4>
                    New on our platform?
                    <Link to={"#"} className="hover-a">
                      {" "}
                      {"  "}
                      Contact Sales
                    </Link>
                  </h4>
                </div>

                <div className="form-setlogin or-text" hidden>
                  <h4>OR</h4>
                </div>

                <div className="form-sociallink" hidden>
                  <ul className="d-flex">
                    <li>
                      <Link to="#" className="facebook-logo">
                        <ImageWithBasePath
                          src="assets/img/icons/facebook-logo.svg"
                          alt="Facebook"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/google.png"
                          alt="Google"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="apple-logo">
                        <ImageWithBasePath
                          src="assets/img/icons/apple-logo.svg"
                          alt="Apple"
                        />
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2024 DataVision. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
